var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessfulTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.1,
    height: 23.1,
    viewBox: "0 0 24.1 23.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 162590"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#459f45",
    d: "M13.2.8a3.8 3.8 0 0 1 4.2 1.4 3.8 3.8 0 0 0 1.8 1.3 3.8 3.8 0 0 1 2.6 3.6 3.8 3.8 0 0 0 .7 2.2 3.8 3.8 0 0 1 0 4.4v.1a3.8 3.8 0 0 0-.7 2.1v.1a3.8 3.8 0 0 1-2.5 3.6 3.8 3.8 0 0 0-1.9 1.3 3.8 3.8 0 0 1-4.2 1.4 3.8 3.8 0 0 0-2.3 0A3.8 3.8 0 0 1 6.7 21a3.8 3.8 0 0 0-1.8-1.4A3.8 3.8 0 0 1 2.2 16a3.8 3.8 0 0 0-.7-2.2 3.8 3.8 0 0 1 0-4.4 3.8 3.8 0 0 0 .7-2.2V7a3.8 3.8 0 0 1 2.5-3.6 3.8 3.8 0 0 0 1.9-1.3A3.8 3.8 0 0 1 11 .8a3.8 3.8 0 0 0 2.3 0Z",
    "data-name": "Polygon 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdfdfd",
    d: "M9.8 14 7 11.3l-1 1L9.8 16 18 7.8l-1-1Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfulTick);
export default __webpack_public_path__ + "static/media/successful-tick.4b4a91c292916ca572341d78365c06e8.svg";
export { ForwardRef as ReactComponent };